export default {
  testimonialtwo: {
    subtitle: "Testimonials",

    title1: "What",
    title2: "Businesses Say",

    desc:
      "Restaurants and suppliers trust MAHAL to simplify sourcing, ensure transparency, and build long-term partnerships.",

    review:
      "MAHAL has made our procurement process faster and more transparent. The supplier network and order tracking features are extremely reliable.",

    cta: "Join MAHAL Today",

    users: [
      { name: "Bartholomew", role: "Restaurant Owner" },
      { name: "Sophie Dennison", role: "Procurement Manager" },
      { name: "Israt Jahan", role: "Business Partner" },
    ],
  },
};